import styles from './styles.scss'

export default `
<div class="${styles.close}" data-menu-close>
  <svg
    class="${styles.closeIcon}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      fill-rule="evenodd"
      d="M0 20V0m20 0v20M16.18 4.88 11.06 10l5.12 5.12a.5.5 0 0 1 0 .7l-.36.36a.5.5 0 0 1-.7 0L10 11.06l-5.12 5.12a.5.5 0 0 1-.7 0l-.36-.36a.5.5 0 0 1 0-.7L8.94 10 3.82 4.88a.5.5 0 0 1 0-.7l.36-.36a.5.5 0 0 1 .7 0L10 8.94l5.12-5.12a.5.5 0 0 1 .7 0l.36.36a.5.5 0 0 1 0 .7"
    />
  </svg>
</div>
<div class="${styles.inner}" data-menu-inner>
  <ul class="${styles.section}" data-menu-section="menu">
  <% if (levels.length) { %>
    <li class="${styles.item}" data-menu="levels">
      <svg
        class="${styles.buttonIcon}"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          d="M0 20V0m20 0v20m-10-8.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M10 2a8 8 0 0 0-2.33.35.98.98 0 0 0-.67.94v.94l-.5.29-.8-.47a1.02 1.02 0 0 0-1.21.16 7.98 7.98 0 0 0-2.26 3.9 1.02 1.02 0 0 0 .47 1.14l.81.47v.56l-.81.47a1.02 1.02 0 0 0-.47 1.14 7.98 7.98 0 0 0 2.26 3.9c.33.31.82.38 1.21.16l.8-.47.5.29v.94c0 .42.26.82.67.94a8 8 0 0 0 4.66 0c.4-.12.67-.52.67-.94v-.94l.5-.29.8.47c.4.22.88.15 1.21-.16a7.98 7.98 0 0 0 2.26-3.9 1.02 1.02 0 0 0-.47-1.14l-.81-.47v-.56l.81-.47c.4-.23.57-.7.47-1.13a7.98 7.98 0 0 0-2.26-3.9 1.02 1.02 0 0 0-1.21-.17l-.8.47-.5-.28v-.95a.98.98 0 0 0-.67-.94A8 8 0 0 0 10 2m0 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-9.5c.51 0 1.01.06 1.5.17v1.14c0 .18.1.35.25.44l1.5.86a.5.5 0 0 0 .5 0l.97-.57a6.43 6.43 0 0 1 1.5 2.6l-.98.57a.5.5 0 0 0-.25.43v1.72a.5.5 0 0 0 .25.43l.98.57a6.43 6.43 0 0 1-1.5 2.6l-.98-.57a.5.5 0 0 0-.5 0l-1.49.87a.5.5 0 0 0-.25.43v1.14a6.54 6.54 0 0 1-3 0v-1.14a.5.5 0 0 0-.25-.43l-1.5-.87a.5.5 0 0 0-.5 0l-.97.57a6.43 6.43 0 0 1-1.5-2.6l.98-.57a.5.5 0 0 0 .25-.43V9.14a.5.5 0 0 0-.25-.43l-.98-.57a6.43 6.43 0 0 1 1.5-2.6l.98.57a.5.5 0 0 0 .5 0l1.49-.87a.5.5 0 0 0 .25-.43V3.67c.49-.11.99-.17 1.5-.17"
        />
      </svg>
      Качество
      <span data-level-label></span>
    </li>
    <% } %>
    <% if (rates.length) { %>
      <li class="${styles.item}" data-menu="rates">
        <svg
          class="${styles.buttonIcon}"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M10 3a8 8 0 0 1 6.245 13h-2.091a6.5 6.5 0 1 0-8.307 0H3.754A8 8 0 0 1 10 3zm2.758 4.182a.3.3 0 0 1 .424 0l.636.636a.3.3 0 0 1 0 .424l-1.233 1.234a3 3 0 1 1-1.06-1.06h-.001zM10 9.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM.5 0v20m19-20v20"
          />
        </svg>
        Скорость
        <span data-rate-label></span>
      </li>
    <% } %>
    <% if (share) { %>
      <li class="${styles.item}" data-share>
          <svg
          class="${styles.buttonIcon}"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M20 0v20M0 0v20m14-8a2.98 2.98 0 0 0-2.17.94L7.9 10.75c.07-.24.11-.49.11-.75s-.04-.5-.1-.75l3.93-2.19A2.98 2.98 0 0 0 14 8a3 3 0 1 0-3-3c0 .26.04.5.1.75L7.18 7.94A2.98 2.98 0 0 0 5 7a3 3 0 1 0 0 6 2.98 2.98 0 0 0 2.17-.94l3.94 2.19A3 3 0 0 0 11 15a3 3 0 1 0 3-3M5 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m9 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m0-10a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
          />
        </svg>
        Поделиться
      </li>
    <% } %>
  </ul>
  <% if (levels.length) { %>
    <ul class="${styles.section}" data-menu-section="levels">
      <% for (var i = 0; i < levels.length; i++) { %>
        <li class="${styles.item}" data-level="<%= levels[i].id %>"
          ><%= levels[i].label %></li>
      <% }; %>
      <li class="${styles.item}" data-level="-1">Авто</li>
    </ul>
    <% } %>
    <% if (rates.length) { %>
      <ul class="${styles.section}" data-menu-section="rates">
        <% for (var i = 0; i < rates.length; i++) { %>
        <li class="${styles.item}" data-rate="<%= rates[i].value %>"
          >
          <%= rates[i].value === "1.0" ? 'Обычная' : rates[i].label %>
          </li>
        <% }; %>
      </ul>
    <% } %>
</div>`
